/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import Select from 'react-select';

import { isMobile } from '../../components/breakpoints';

import { IEcommLiveStreamMobileViewProps } from './ecomm-live-stream-mobile';

export class EcommLiveStreamMobileView extends React.PureComponent<IEcommLiveStreamMobileViewProps> {
  public state: any = { width: 0, currFloor: 0, floors: [], hasMounted: false };

  public componentDidMount(): void {
    if (!this.state.hasMounted) {
      window.addEventListener('resize', this._updateDimensions);

      this.setState({ width: window.innerWidth, hasMounted: true });
    }
  }

  public render(): JSX.Element | null {
    const { streams } = this.props;

    if (!isMobile(this.state.width)) {
      return null;
    }

    let tmp: { value: number, label: string }[] = [];

    if (streams && this.state.floors.length === 0) {
      streams.map((item, index) => tmp.push({ value: index, label: item.streamName }));

      this.setState(() => { return { currFloor: 0, floors: tmp }; });
    }

    const floorSelectorStyle = streams && streams.length > 1 ? 'mobile-floor-selector' : 'no-display';

    return (
      <div>
        <div className='ecomm-live-stream-mobile'>
          <Select
            className={floorSelectorStyle}
            placeholder={streams[this.state.currFloor].streamName}
            options={this.state.floors}
            onChange={this._setFloor}
            isSearchable={false}
          />
          <div className='mobile-video'>{this._renderPlayer()}</div>
          {this._renderMobileSchedule()}
        </div>
      </div>
    );
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this._updateDimensions);
  }

  private _renderPlayer(): JSX.Element | null {
    const { streams } = this.props;

    // const canPlay = ReactPlayer.canPlay(streams[this.state.currFloor].streamUrl) ? true : false;

    return (
      <div id='player-wrapper' className='player-wrapper'> 
        <iframe className='player' src={streams[this.state.currFloor].streamUrl+"embed"} width="640" height="360" frameBorder="0" allow="autoplay; fullscreen" allowFullScreen scrolling="no"></iframe>
      </div>
    );
  }

  private _renderMobileSchedule(): JSX.Element | null {
    const { current} = this.props;

    return (
      <div className='ecomm-live-stream-mobile-sutras'>
        {current}
      </div>
    );
  }

  private _setFloor = (event: any) => {
    this.setState(() => { return { currFloor: event.value }; });
  }

  private _updateDimensions = () => {
    this.setState({ width: window.innerWidth });
  }; 
}

export default EcommLiveStreamMobileView;